var textAlignCenterSmDown = {
  "@media (max-width: 767px)": {
    "textAlign": "center !important"
  }
};

export { textAlignCenterSmDown };
